"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHouseFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M11.993 2c.492 0 .938.167 1.338.502l8.322 6.743c.328.349.414.726.258 1.132-.156.407-.465.61-.927.612L20 11v9c0 1.333-.667 2-2 2h-2c-1.333-.01-2-.676-2-2v-6h-4v5.986c0 1.324-.667 1.99-2 2H6c-1.333.01-2-.653-2-1.986l-.004-9-1.028-.011c-.483 0-.786-.204-.911-.612-.125-.407-.043-.786.246-1.136l8.352-6.739c.4-.335.847-.502 1.338-.502z' }))); };
exports.default = SvgHouseFilled;
//# sourceMappingURL=HouseFilled.js.map